import { makeStyles } from '@material-ui/core/styles';

export const useDetailStyles = makeStyles((theme) => ({
    interfaceSelect: {
        '& .MuiSelect-select': {
            minWidth: 225,
        },
    },

    agentAccessSelection: {
        '& .MuiSelect-select': {
            minWidth: 250,
        },
    },

    agentSnmpSelection: {
        '& .MuiSelect-select': {
            minWidth: 250,
        },
        paddingRight: theme.spacing(1),
    },

    sshButtonContainer: {
        '& button': {
            marginTop: theme.spacing(3),
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(3),
        },

        '& svg': {
            marginBottom: theme.spacing(1),
        },
    },

    sshHelpTip: {
        marginBottom: theme.spacing(1),
    },
}));
